import React from 'react';
import styled from 'styled-components';

import Wrapper from './wrapper';
import { media } from '../helpers';

import Circles from '../../images/about-banner-circles.inline.svg';

const CircleBannerContainer = styled.div`
    position: relative;
    overflow: hidden;
    ${media.large`max-height: 45vh;`}

    &.lg {
        ${media.large`max-height: 65vh;`}

        .content-container {
            top: 20vh;
            ${media.small`top: 20vh;`}
        }
    }
    .svg-container {
        max-width: 100vw;
        position: relative;
        min-height: 50vh;
        ${media.medium`min-height: 40vh;`}
        svg {
            max-width: 100vw;
            width: 100%;
            height: auto;
            position: absolute;
            height: 100%;
            ${media.large`position: static;`}
            g {
                mask: none;
            }
        }
    }

    .content-container {
        position: absolute;
        left: 0;
        width: 100%;
        top: 17vh;
        max-width: 100vw;
        ${media.small`top: 15vh;`}
        /* ${media.laptop`top: 16vh;`} */
        ${media.xl`top: 15vh;`}
        .inner-wrap {
            text-align: center;
            max-width: 90vw;
            margin: 0 auto;
            ${media.large`max-width: 65vw;`}
            h1 {
                font-family: neue-kabel, sans-serif;
                font-weight: 800;
                font-size: 2.5rem;
                margin: 0 0 15px;
                color: #fff;
                ${media.small`font-size: 3em;`}
                ${media.large`font-size: 3.5rem;`}
                ${media.laptop`font-size: 4rem;`}
            }

            p {
                font-size: 1rem;
                margin: 0;
                color: #fff;
                line-height: 1.5;
                margin: 0 auto;
                ${media.small`font-size: 1.1rem;`}
                ${media.medium`font-size: 1.2rem;`}
                ${media.laptop`font-size: 1.3rem;`}
                ${media.large`max-width: 950px;`}
            }
        }
    }
`;

const CircleBanner = ({ content, lg }) => {
    const { bannerHeadline, bannerCaption, bannerBgColor } = content || {};
    return (
        <CircleBannerContainer className={lg ? 'lg' : ''}>
            <div
                className="svg-container"
                style={{ backgroundColor: bannerBgColor }}
            >
                <Circles />
            </div>
            <Wrapper className="content-container">
                <div className="inner-wrap">
                    <h1>{bannerHeadline}</h1>
                    <p>{bannerCaption}</p>
                </div>
            </Wrapper>
        </CircleBannerContainer>
    );
};

export default CircleBanner;
